import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import "./index.css";

import i18n from "./i18n";

import { initHyperDX } from "./hyperdx.ts";
import { createReactErrorHandler, initSentry } from "./sentry.ts";

import App from "./App";
import GoogleAnalytics from "./components/GoogleAnalytics";
import InAppBrowserGate from "./components/InAppBrowserGate";

import { resolveLocaleFromQuery } from "./hooks/resolveLocaleFromQuery";

async function bootstrap() {
  const locale = resolveLocaleFromQuery(window.location.search);
  if (locale) {
    await i18n.changeLanguage(locale);
  }

  createRoot(document.getElementById("root")!, {
    onUncaughtError: createReactErrorHandler(),
  }).render(
    <ErrorBoundary
      fallback={<div>Unexpected error occurred.</div>}
      onError={createReactErrorHandler()}
    >
      <InAppBrowserGate>
        <BrowserRouter>
          <GoogleAnalytics />
          <Routes>
            <Route path="/consult" element={<App />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </InAppBrowserGate>
    </ErrorBoundary>,
  );
}

initSentry();
initHyperDX();
bootstrap();
